module.exports = __webpack_public_path__ + "static/media/tanishq1.9575c03a.jpg";